import { ContentPicker } from '../../ui/ContentPicker'

/**
 * Choosing something that already exists and laying it on the board.
 *
 * It is the shared picker with the board's words on it — see `ui/ContentPicker`, which was this file
 * until a session needed the same thing. What is board-specific is exactly what stands below: which
 * kinds may be laid down, and the sentence that says a card points at something rather than copying
 * it.
 *
 * **A card and a link choose from different sets**, which is why the kinds are a parameter. A board
 * holds cards for the things it can draw; an appointment is not one of them today, because a card
 * showing a lecture would have to draw a week grid on a tile.
 */
export interface PutDownProps {
  readonly onChoose: (what: { kind: string; id: string; label: string }) => void
  readonly onClose: () => void
}

export function PutDown({ onChoose, onClose }: PutDownProps) {
  return (
    <div className="board__put">
      <ContentPicker
        kinds={['document', 'note', 'task']}
        label="Find something of yours to lay on the board"
        placeholder="A document, a note, an open point"
        lead="Everything you already have: documents in your library, notes on your pad, open points on your list. What you lay down is a card pointing at it, never a copy."
        onChoose={onChoose}
        onClose={onClose}
      />
    </div>
  )
}
